// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3aeb23c1","952":"4e83c6f0"}[chunkId] + ".chunk.js";
};